export { ContentArticle } from './ContentArticle';
export {
  Destination as DestinationContentModule,
  Faq as FaqsContentModule,
  LinkLists as LinkListsContentModule,
  StandardContent as StandardContentModule,
  Tabs as TabsContentModule,
  TextImage as TextImageContentModule,
  SupplierReviews as SupplierReviewsContentModule,
} from './contentModule';
